import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {appRouter} from '@netx/core-next/instance/router';
import {getPrefixedLogger} from '@netx/core-next/instance/logger';
import {spawnNewWindow} from '@netx/core-next/utils/browser';
import {FindLegacyAction} from '@netx/core/legacyActionManager';

const logger = getPrefixedLogger('utils/performLegacyAction');

export const performLegacyAction = (
	actionStr: string,
	actionArgs: any[] = [],
) => {
	logger.silly('utils/performAction', actionStr);

	const action = FindLegacyAction(actionStr);
	if (!action) throw new Error(`'${actionStr}' is not a registered action`);

	// Generic handler for all Action clicks:
	if (action.fake) {
		logger.warn(`The action '${action.event}' has not been registered`);
	}
	// or else, if the action itself defined a wrapper, run the arguments through that.
	else if (typeof action.wrapper === 'function') {
		actionArgs = action.wrapper.apply(this, actionArgs);
		if (!Array.isArray(actionArgs)) {
			throw new Error(
				`Action wrapper for '${action.event}' did not return an array`,
			);
		}
	}

	// close any/all open dropdown menus
	dispatcher.trigger('app:close:menus');

	// If this action has a route, route to it
	if (typeof action.route === 'function') {
		// route can be a function that takes args & returns a string
		appRouter.navigate(action.route.apply(action, actionArgs) as string, true);
	} else if (typeof action.route === 'string') {
		// it can also be a plain string.
		// TODO: such actions could be rendered as simple hrefs that can be enabled/disabled, so the browser can do this part ...
		appRouter.navigate(action.route, true);
	}
	// If this action has a link, send the browser to it.
	// (Again, this could have been rendered as a simple href ...)
	else if (typeof action.link === 'string') {
		spawnNewWindow(action.link);
		// a link could be of the format "#route", or "/other/site/on/this/host" or even "http://google.com"
		// window.location = action.link;
	}
	// If no view & no route, trigger this action's event
	else {
		actionArgs.unshift(action.event);
		dispatcher.trigger.apply(dispatcher, actionArgs as unknown as any);
	}
};
